import { useState, useEffect, useCallback } from "react";
import {
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  CircularProgress,
  DialogActions,
  Button,
  Divider,
} from "@material-ui/core";
import MaskAndValid from "utils/maskAndValid";
import Api from "lib/api/httpRequestHelper";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";

import { Close, LocalShipping } from "@mui/icons-material";

export default function DialogOcorrenciasTransporte({
  open,
  onClose,
  chaveNf,
  numero,
  serie,
}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const snackbar = useSnackbar();

  const fetchOccurencesData = useCallback(async () => {
    setLoading(true);
    setData(null);

    try {
      const value = await Api.get(
        "tracking-occurrences",
        "sellinorder",
        "?chaveNF=" + chaveNf,
        true
      );

      if (
        value?.ErrorMessage ===
        "HTTPERRO 422 Não foi possível encontrar ocorrências de entrega. Verifique os parâmetros informados."
      ) {
        snackbar.showMessage(
          "Não foi possível encontrar ocorrências de entrega para essa nota.",
          {
            severity: "info",
          }
        );
        onClose();
      } else if (!value || value.Result?.Ocorrencias?.length === 0) {
        snackbar.showMessage(
          "Não foram encontradas ocorrências de entrega para essa nota.",
          {
            severity: "info",
          }
        );
        onClose();
      } else {
        setData(value.Result);
      }
    } catch (error) {
      snackbar.showMessage(
        error.message || "Erro ao buscar ocorrências de entrega",
        {
          severity: "error",
        }
      );
      console.log(error);
      onClose();
    } finally {
      setLoading(false);
    }
  }, [chaveNf, snackbar, onClose]);

  useEffect(() => {
    if (open && chaveNf) {
      fetchOccurencesData();
    } else {
      setData(null);
    }
  }, [open, chaveNf, fetchOccurencesData]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg">
      <DialogTitle>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h4">
            <LocalShipping fontSize="small" />
            Ocorrências de Entrega da Nota {numero || ""} - {serie || ""}
          </Typography>
          <IconButton aria-label="close" onClick={onClose} size="small">
            <Close />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent>
        {loading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "200px",
            }}
          >
            <CircularProgress />
          </div>
        )}
        {data && (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h3" color="primary">
                Informações de transporte
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={4}>
                  <Typography variant="h4">Nome da transportadora</Typography>
                  <Typography variant="caption">
                    {data.NomeTransportadora || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <Typography variant="h4">Quantidade de volumes</Typography>
                  <Typography variant="caption">
                    {data.QtdVolumesNf || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <Typography variant="h4">CNPJ</Typography>
                  <Typography variant="caption">
                    {MaskAndValid.maskCNPJ(data?.CnpjTransportadora) || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <Typography variant="h4">Peso bruto</Typography>
                  <Typography variant="caption">
                    {MaskAndValid.maskPrice(data?.PesoBrutoTotal) + " kg" ||
                      "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <Typography variant="h4">Previsão de entrega</Typography>
                  <Typography variant="caption">
                    {MaskAndValid.formattDateBR(data?.DataPrevisaoEntrega) ||
                      "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <Typography variant="h4">Data de entrega</Typography>
                  <Typography variant="caption">
                    {MaskAndValid.formattDateBR(data?.DataEntrega) || "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {data?.Ocorrencias?.length > 0 && (
              <Grid item xs={12}>
                <Typography variant="h3" color="primary">
                  Ocorrências de entrega
                </Typography>
                {data.Ocorrencias?.map((ocorrencia, index, key) => (
                  <>
                    <Grid
                      container
                      spacing={2}
                      key={key}
                      style={{ margin: "0.5rem 0" }}
                    >
                      <Grid item xs={3} md={1}>
                        <IconButton size="small" color="primary">
                          <LocalShipping />
                        </IconButton>
                      </Grid>

                      <Grid item xs={9} md={11}>
                        <Typography variant="h5">
                          {ocorrencia.DataOcorrencia?.includes("T00:00:00")
                            ? MaskAndValid.formattDateBR(
                                ocorrencia.DataOcorrencia
                              )
                            : MaskAndValid.formattDateHourBR(
                                ocorrencia.DataOcorrencia
                              )}
                        </Typography>

                        <Typography variant="caption">
                          {ocorrencia.NomeOcorrencia}
                        </Typography>
                        <Typography variant="caption">
                          {ocorrencia.Observacao}
                        </Typography>
                      </Grid>
                    </Grid>
                    {index !== data.Ocorrencias.length - 1 && <Divider />}
                  </>
                ))}
              </Grid>
            )}
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={onClose}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
